import { observer } from '@formily/reactive-vue'
import { h, useParentForm } from '@formily/vue'
import { defineComponent } from 'vue-demi'
import { Button as RichButton } from '@didi/rich-ui'
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export const Reset = observer(
  defineComponent({
    name: 'FReset',
    props: ['onClick', 'onReset'],
    setup(props, { attrs, slots, listeners }) {
      const formRef = useParentForm()

      return () => {
        const { onClick = listeners && listeners.click, onReset = listeners && listeners.reset } =
          props

        const form = formRef.value
        return h(
          RichButton,
          {
            attrs: {
              nativeType: listeners && listeners.onReset ? 'button' : 'onReset',
              type: 'primary',
              outline: true,
              ...attrs,
              loading: attrs.loading !== undefined ? attrs.loading : form.onResetting,
            },
            on: {
              ...listeners,
              click: e => {
                if (onClick) {
                  if (onClick(e) === false) return
                }
                if (onReset) {
                  form.reset()
                }
              },
            },
          },
          slots,
        )
      }
    },
  }),
)

export default Reset
